import { styled } from "styled-components";
import { PopupBtn } from "@template/components/Popup/styles.ts";

export const AuthContainer = styled.div`
  display: flex;
  justify-self: flex-end;
  align-items: center;
  height: max-content;
  width: max-content;
  gap: 8px;
  flex-wrap: nowrap;
  ${({ theme }) => theme.breakpoints.md.query} {
    > ${PopupBtn}:last-of-type {
      width: 100%;
    }
  }
`;
